import React, { useCallback, useEffect, useState } from 'react'
import DataTableForCustomPaginationRoute from '../../../../components/DataTableForCustomPaginationRoute'
import { nameSource } from '../domain/info'
import { headers } from '../domain/headers'
import { breadcrumbList } from '../domain/breadcrumb'
import Container from '../../../../components/Container'
import moment from 'moment'
import { INPUT_MASK } from '../../../../common/constants'
import { toolsList } from '../domain/tools'
import Form, { Select } from '../../../../components/Form'
import { useHistory } from 'react-router-dom'
import { StringParam, useQueryParam } from 'use-query-params'
import { phoneMask } from '../../../../utils/mask'
import { apiListPagination } from '../domain/api'

const LeadsList: React.FC = () => {
  const history = useHistory()
  const [title] = useQueryParam('title', StringParam)
  const [statusQuery] = useQueryParam('status', StringParam)
  const [searchParameters, setSearchParameters] = useState<any[]>(undefined)

  const handleFilter = useCallback(
    (data: { travel_agency: number }) => {
      setSearchParameters([
        {
          travel_agency: data.travel_agency,
          status: statusQuery || undefined
        }
      ])
    },
    [statusQuery]
  )

  const handleClearFilter = useCallback(async () => {
    setSearchParameters([
      {
        status: statusQuery
      }
    ])
  }, [statusQuery])

  useEffect(() => {
    setSearchParameters([
      {
        status: statusQuery
      }
    ])
  }, [statusQuery])

  return (
    <>
      <Container
        pageTitle={title || 'Listagem'}
        breadcrumb={breadcrumbList}
        tools={toolsList}
      >
        <Form onSubmit={handleFilter}>
          <div className="form">
            <div className="row mb-5">
              <Select
                className="col-md-3"
                name="travel_agency"
                label="Agencia de viagem"
                options={[
                  {
                    name: 'SIM',
                    value: 1
                  },
                  {
                    name: 'NÃO',
                    value: 0
                  }
                ]}
                blank
                defaultValue=""
              />
            </div>
          </div>

          <div className="d-flex justify-content-end">
            <div className="col-md-1 d-flex justify-content-end">
              <button
                type="reset"
                className="btn btn-light-primary"
                onClick={handleClearFilter}
              >
                Limpar
              </button>
            </div>
            <div className="col-md-1 d-flex justify-content-end">
              <button type="submit" className="btn btn-primary">
                Filtrar
              </button>
            </div>
          </div>
        </Form>

        <DataTableForCustomPaginationRoute
          paginationUrl={apiListPagination()}
          source={nameSource}
          notHasChildren
          headers={headers}
          searchParameters={searchParameters}
          customHeaders={[
            {
              name: 'Celular',
              field: 'phone',
              sortable: true,
              element: item => {
                if (!item?.phone) {
                  return <p></p>
                }
                return <p>{phoneMask(item?.phone)}</p>
              }
            }
          ]}
          actions={[
            {
              name: 'Atualizar',
              title: 'Atualizar',
              onClick: item => {
                if (statusQuery) {
                  history.push(
                    `/commercial/leads/update/${item.id}?status=${statusQuery}&title=${title}`
                  )
                  return
                }
                history.push(`/commercial/leads/update/${item.id}`)
              },
              element: () => {
                return <span className="fa fa-edit"></span>
              }
            }
          ]}
        />
      </Container>
    </>
  )
}

export default LeadsList
